import { render, staticRenderFns } from "./MarkCombos.vue?vue&type=template&id=16f163d3&scoped=true"
import script from "./MarkCombos.vue?vue&type=script&lang=js"
export * from "./MarkCombos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f163d3",
  null
  
)

export default component.exports